import React from 'react'
import styled from 'styled-components'
import {
  colors,
  spacing,
  heading,
  body,
  typographyMixin,
  borderRadius,
  mediaQuery,
} from 'src/constants/marketing-ds'

const HeroSection = ({ lang, market, channels }) => {
  return (
    <StyledHeroSection>
      <HeroContent>
        <HeroHeader>
          <LogoContainer>
            <LogoImage
              src="https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/FuboStore_Logo_FullColor_rgb.svg"
              alt="Fubo Channel Store"
            />
          </LogoContainer>

          <HeadlineContainer>
            <MainHeadline>Watch more. Pay less.</MainHeadline>
            <Subheadline>Access individual channels without a Fubo base plan.</Subheadline>
          </HeadlineContainer>
        </HeroHeader>

        <ChannelGrid channelCount={channels.length}>
          {channels.map((channel) => (
            <ChannelCard key={channel.id} href={`#${channel.id}`}>
              <ChannelImage src={channel.carouselImage} alt={channel.name} />
            </ChannelCard>
          ))}
        </ChannelGrid>
      </HeroContent>
    </StyledHeroSection>
  )
}

export default HeroSection

const StyledHeroSection = styled.section`
  width: 100%;
  box-sizing: border-box;
  padding: ${spacing.xxl} ${spacing.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url('https://assets-imgx.fubo.tv/marketing/lp/images/channel-store/hero-bg-v3.jpg');
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
  background-color: ${colors.black};

  ${mediaQuery.tablet} {
    padding: ${spacing.xxxxl} ${spacing.xl};
  }
`

const HeroContent = styled.div`
  width: 100%;
  max-width: ${({ theme }) => '1400px'};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.xl};
  position: relative;
  z-index: 1;

  ${mediaQuery.tablet} {
    gap: 112px;
  }
`

const HeroHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  width: 100%;
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.xxxs};
`

const LogoImage = styled.img`
  width: 130px;
  height: 76px;
  object-fit: contain;
`

const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};
  max-width: 600px;
  text-align: center;
`

const MainHeadline = styled.h1`
  ${typographyMixin(heading.xl)};
  color: ${colors.white};
  margin: 0;

  ${mediaQuery.tablet} {
    ${typographyMixin(heading.xxl)};
  }
`

const Subheadline = styled.p`
  ${typographyMixin(body.lg)};
  color: ${colors.white};
  margin: 0;
`

const ChannelGrid = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18.374px;

  ${mediaQuery.tablet} {
    gap: ${spacing.md};
  }

  ${mediaQuery.desktop} {
  }
`

const ChannelCard = styled.a`
  display: block;
  aspect-ratio: 196 / 294;
  border-radius: ${borderRadius.md};
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s ease;
  flex: 0 0 calc(50% - 10px);
  min-width: 130px;

  ${mediaQuery.tablet} {
    flex: 0 0 calc(33.333% - ${spacing.md});
  }

  ${mediaQuery.desktop} {
    flex: 0 0 calc(20% - ${spacing.md});
  }

  &:hover {
    transform: translateY(-4px);
  }
`

const ChannelImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`
